import React from "react";
import { connect } from "react-redux";
import { DataGrid, Button } from "devextreme-react";
import { Column, RemoteOperations, Paging, Pager } from "devextreme-react/ui/data-grid";
import ReactDOM from "react-dom";
import { Tooltip } from "devextreme-react/ui/tooltip";
import { doGetFiltrosCentros, openCloseModalEditarCentro, doGetListasCentros, doGetCentros, openCloseModalEliminarCentro, doGetCentroData, resetStatus } from "./action";
import { filterType } from "../../../../../helpers/filterHelper";
import TableFilter from "../../../../Shared/tableFilter";
import EmptyIcon from "../../../../Shared/EmptyIcon";
import ToolTipsLista from "../../../../Shared/toolTipsLista";
import ModalEditar from "./modalEditar";
import ModalDelete from "./modalDelete";
import ModalDesactivar from "./modalDesactivar";
import validaciones from "../../../../../helpers/validaciones";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";

class Centros extends React.PureComponent {
  constructor(props) {
    super(props);
    if ((props.listaPools && props.listaPools.length === 0)
      || (props.listaAdditionalExams && props.listaAdditionalExams.length === 0)
      || (props.listaPsychologicalExams && props.listaPsychologicalExams.length === 0)) {
      this.props.dispatch(doGetListasCentros());
    }

    if (!this.props.filtrosCentros) this.props.dispatch(doGetFiltrosCentros());
    if (!(this.props.listaCentros && this.props.listaCentros.length)) this.props.dispatch(doGetCentros(null, true));
  }

  componentWillUnmount = () => {
    this.props.dispatch(resetStatus());
  }

  handleFilterChange = (text, filters) => {
    const currentFilters = [...filters];
    if (text) {
      currentFilters.push({ column: "Description", value: { text, value: text }, type: filterType.search });
      currentFilters.push({ column: "Code", value: { text, value: text }, type: filterType.search });
    }
    this.props.dispatch(doGetCentros(currentFilters));
  }

  handleAdd = () => {
    this.props.dispatch(openCloseModalEditarCentro(true, {}, true));
  }

  handleDelete = (e) => {
    this.props.dispatch(openCloseModalEliminarCentro(true, e.data));
  }

  handleEdit = (e) => {
    this.props.dispatch(doGetCentroData(e.data));
  }

  render() {
    const { listaCentrosFiltrados } = this.props;
    return (
      <React.Fragment>
        <ModalEditar />
        <ModalDelete />
        <ModalDesactivar />
        <TableFilter
          placeholder="Buscar centro"
          onChange={this.handleFilterChange}
          filters={this.props.filtrosCentros}
          show
          buttons={{
            filter: { buttonName: "iconFilter", visible: true, buttonAction: null },
            document: { buttonName: "iconDocument", visible: false, buttonAction: null },
            download: { buttonName: "iconDownload", visible: false, buttonAction: null },
            newItem: {
              buttonName: "custom", visible: true, buttonAction: this.handleAdd, buttonText: "Agregar centro",
            },
          }}
        />
        {this.props.isLoading && <LoadingOverlay />}
        <DataGrid
          dataSource={listaCentrosFiltrados}
          noDataText=""
          className="custom-table"
          showBorders={false}
          showColumnLines={false}
          allowColumnResizing={false}
          columnAutoWidth={false}
          showRowLines={false}
          rowAlternationEnabled
          onContentReady={(e) => {
            if (e.component.totalCount() === 0) {
              const config = {};
              config.addClass = "table-margin";
              const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
              const element = validaciones.noDataDOMElement(config, "Sin centros");
              noDataSpan.appendChild(element);
            }
          }}
        >
          <Column
            dataField="Description"
            allowSearch
            caption="Centro"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="group-Column-inline">
                  {row.data.Procesando ?
                    <div className="material-icons" style={{ fontSize: "inherit" }}>schedule</div>
                    :
                    <EmptyIcon size={13} full={row.data.Status === 1} />}
                  <div className="text space-text"> {row.data.Description}</div>
                </div>
                , element
              );
            }}
          />
          <Column
            dataField="Territory"
            alignment="center"
            caption="Territorio"
          />

          <Column
            dataField="WeekScheduler"
            alignment="center"
            caption="Horario semana"
          />

          <Column
            width="150px"
            dataField="WeekEndScheduler"
            alignment="center"
            caption="Horarios fin de semana"
          />

          <Column
            dataField="ListaBaterias"
            allowSearch
            alignment="left"
            caption="Prestaciones"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div>
                  {(row.data.PoolDetail && row.data.PoolDetail.split(",").length > 0) &&
                    <span id={`idBateria_${row.data.Id}`} className="back-circular-baterias">{`${row.data.PoolDetail ? row.data.PoolDetail.split("|").length : 0}B`}</span>}
                  {(row.data.ExamDetail && row.data.ExamDetail.split(",").length > 0) &&
                    <span id={`idPrestacion_${row.data.Id}`} className="back-circular-prestaciones">{`${row.data.ExamDetail ? row.data.ExamDetail.split("|").length : 0}P`}</span>}
                  {(row.data.ExamCielDetail && row.data.ExamCielDetail.split(",").length > 0) &&
                    <span id={`idCiel_${row.data.Id}`} className="back-circular-ciel">{`${row.data.ExamCielDetail ? row.data.ExamCielDetail.split("|").length : 0}C`}</span>}
                  {(row.data.PoolDetail && row.data.PoolDetail.split(",").length > 0) &&
                    <Tooltip
                      contentRender={() =>
                        (<ToolTipsLista key={row.data.Id} listaIds={row.data.PoolDetail.split(",")} />)}
                      position="bottom"
                      target={`#idBateria_${row.data.Id}`}
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                    />
                  }

                  {(row.data.ExamDetail && row.data.ExamDetail.split(",").length > 0) &&
                    <Tooltip
                      contentRender={() =>
                        (<ToolTipsLista key={row.data.Id} listaIds={row.data.ExamDetail.split(",")} />)}
                      position="bottom"
                      target={`#idPrestacion_${row.data.Id}`}
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                    />
                  }
                  {(row.data.ExamCielDetail && row.data.ExamCielDetail.split(",").length > 0) &&
                    <Tooltip
                      contentRender={() =>
                        (<ToolTipsLista key={row.data.Id} listaIds={row.data.ExamCielDetail.split(",")} />)}
                      position="bottom"
                      target={`#idCiel_${row.data.Id}`}
                      showEvent="mouseenter"
                      hideEvent="mouseleave"
                    />
                  }
                </div>
                , element
              );
            }}
          />
          <Column
            dataField="Code"
            alignment="left"
            caption="Código SAP"
          />

          <Column
            caption=""
            alignment="right"
            cellTemplate={(element, row) => {
              ReactDOM.render(
                <div className="button-column">
                  <Button
                    className="slimButton"
                    type="success"
                    style={{ marginRight: 5 }}
                    text="Editar"
                    onClick={() => this.handleEdit(row)}
                  />

                  <Button
                    className="slimButton"
                    type="danger"
                    text="Eliminar"
                    disabled={row.data.Status === 1}
                    onClick={() => this.handleDelete(row)}
                  />
                </div>
                , element);
            }}
          />

          <RemoteOperations
            paging={false}
            filtering
            summary={false}
            groupPaging={false}
            grouping={false}
            sorting={false}
          />
          <Paging
            defaultPageSize={10}
          />
          <Pager
            showNavigationButtons
            showInfo
            infoText={(page, total) => `Página ${page} de ${total}`}
          />

        </DataGrid>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.mantenedorCentros.isLoading,
  listaCentros: state.mantenedorCentros.listaCentros,
  listaCentrosFiltrados: state.mantenedorCentros.listaCentrosFiltrados,
  filtrosCentros: state.mantenedorCentros.filtrosCentros,
  listaPools: state.mantenedorCentros.listaPools,
  listaAdditionalExams: state.mantenedorCentros.listaAdditionalExams,
  listaPsychologicalExams: state.mantenedorCentros.listaPsychologicalExams,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});
export default connect(mapStateToProps, mapDispatchToProps)(Centros);

